import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const PersonHeadsetCheckIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9.79661 3C13.4922 3 16.8136 6.00661 16.8136 10.4319 17.2736 10.6818 17.5932 11.1735 17.5932 11.7377V11.9818C16.7557 11.9818 15.9624 12.1753 15.2542 12.5208V10.1739C15.2542 7.05448 12.8139 4.53152 9.79661 4.53152 6.77932 4.53152 4.33898 7.05448 4.33898 10.1739V15.0909H3.55932C2.7017 15.0909 2 14.3655 2 13.4788V11.8667C2 11.2702 2.31186 10.7543 2.77966 10.4802 2.77966 5.94212 6.14 3 9.79661 3zM12.4038 15.897C12.2514 16.407 12.1695 16.9483 12.1695 17.5091H7.9322C7.27695 17.5091 6.74576 16.9678 6.74576 16.3 6.74576 15.6322 7.27695 15.0909 7.9322 15.0909H9.9661C10.4827 15.0909 10.9222 15.4274 11.085 15.897H12.4038z"
            fill="#222"
          />
          <path
            d="M8.23729 11.0606C8.23729 11.5058 7.88822 11.8667 7.45763 11.8667 7.02703 11.8667 6.67797 11.5058 6.67797 11.0606 6.67797 10.6154 7.02703 10.2545 7.45763 10.2545 7.88822 10.2545 8.23729 10.6154 8.23729 11.0606zM12.1356 11.8667C12.5662 11.8667 12.9153 11.5058 12.9153 11.0606 12.9153 10.6154 12.5662 10.2545 12.1356 10.2545 11.705 10.2545 11.3559 10.6154 11.3559 11.0606 11.3559 11.5058 11.705 11.8667 12.1356 11.8667z"
            fill="#222"
          />
          <path
            d="M9.83559 5.41818C12.1668 5.41818 14.1003 7.17539 14.4746 9.47267 12.042 9.44848 9.94474 7.98951 8.92339 5.86958 8.51017 8.02982 7.06 9.80315 5.13424 10.6173 4.93152 7.44139 7.47322 5.41818 9.83559 5.41818zM19.1814 15.8657L16.9065 18.1495 16.0051 17.2446 15.3458 17.9064 16.9065 19.4732 19.8407 16.5276 19.1814 15.8657z"
            fill="#222"
          />
          <path
            d="M17.5932 22C20.027 22 22 19.9894 22 17.5091C22 15.0288 20.027 13.0182 17.5932 13.0182C15.1594 13.0182 13.1864 15.0288 13.1864 17.5091C13.1864 19.9894 15.1594 22 17.5932 22ZM17.5932 20.5565C19.2447 20.5565 20.5835 19.1921 20.5835 17.5091C20.5835 15.8261 19.2447 14.4617 17.5932 14.4617C15.9417 14.4617 14.6029 15.8261 14.6029 17.5091C14.6029 19.1921 15.9417 20.5565 17.5932 20.5565Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
